import { createTheme } from "@material-ui/core/styles";

const white = "#ffffff";
// const green = "#99B898";
// const darkGreen = "#708670";
// const tan = "#FECEA8";
// const lightRed = "#FF847C";
// const red = "#E84A5F";
// const offBlack = "#2A363B";
// const grey = "#747474";

const theme = createTheme({
  palette: {
    primary: {
      main: "#21c5cb",
    },
    secondary: {
      main: "#21c5cb",
    },
    info: {
      main: "#021520",
    },
    error: {
      main: "#062e4499",
    },
    mydark: {
      main: "#021520",
    },
    common: {
      white,
    },
    background: {
      default: "#ffffff",
      paper: "#f8fcff",
      primary: "#021520",
      secondary: "#21c5cb",
    },
  },
  typography: {
    h1: {
      fontSize: "3rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    button: {
      fontSize: "1.1rem",
      textTransform: "sentencecase",
      fontWeight: 600,
    },
  },
});

export default theme;
